/* eslint-disable indent */
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { FilaTarefa } from "../models/filas/fila-tarefa";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import {
  AnaliseDescontoStatus,
  FilaTarefaTipoOrdenacao,
  FinSimulacaoStatus,
  StatusTarefa,
  TipoFila,
  TipoTag,
  TipoTarefa,
} from "../models/enum";
import { CarregandoService } from "../services/carregando.service";
import { NotificacaoService } from "../services/notificacao.service";
import { FilaService } from "../services/fila.service";
import { FilaTarefaService } from "../services/fila-tarefa.service";
import { Fila } from "../models/filas/fila";
import { ResumoPedido } from "../models/resumoPedido";
import { PedidoService } from "../services/pedido.service";
import { PremissasService } from "../services/premissas.service";
import { AnaliseDesconto } from "../models/analise-desconto";
import { AnaliseDescontoService } from "../services/analise-desconto.service";
import { UsuarioLogado } from "../models/usuario-logado";
import { GlobalService } from "../services/global.service";
import { MatDialog } from "@angular/material";
import { FilaAddOperadorModalComponent } from "../modals/fila-add-operador-modal/fila-add-operador-modal.component";
import { FilaSelOperadorModalComponent } from "../modals/fila-sel-operador-modal/fila-sel-operador-modal.component";
import { TagGiService } from "../services/tag-gi.service";
import { AnaliseDescontoConclusaoModalComponent } from "../modals/analise-desconto-conclusao-modal/analise-desconto-conclusao-modal.component";
import swal from "sweetalert2";
import { FuncionarioService } from "../services/funcionario.service";
import { AnaliseDescontoComponent } from "../analise-desconto/analise-desconto.component";
import { FilaFuncionario } from "../models/filas/fila-funcionario";
import { FilaFuncionarioService } from "../services/filaFuncionario.service";
import { FilaGestor } from "../models/filas/fila-gestor";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { ObservacoesModalComponent } from "../modals/observacoes-modal/observacoes-modal.component";
import { SelecionarTagModalComponent } from "../modals/selecionar-tag-modal/selecionar-tag-modal.component";
import { Funcionario } from "../models/funcionario";
import { JustificativaModalComponent } from "../modals/justificativa-modal/justificativa-modal.component";
import { HistoricoAnaliseDescontoComponent } from "../historico-analise-desconto/historico-analise-desconto.component";
import { Fileira } from "../models/fileira";
import { FornecedorEstruturaService } from "../services/fornecedor-estrutura.service";
import { UtilitarioService } from "../services/utilitario.service";
import { EstruturasPersonalizadas } from "../models/estruturas-personalizadas";
import { DetalheEstruturaModalComponent } from "../modals/detalhe-estrutura-modal/detalhe-estrutura-modal.component";
import { Financiamento } from "../models/financiamento/financiamento";
import { FinSimulacao } from "../models/fin-simulacao";
import { FinSimulacaoService } from "../services/fin-simulacao.service";
import { FinanciamentoService } from "../services/financiamento.services";
import { FinSimulacaoComponent } from "../financiamento/screens/simulacao/fin-simulacao/fin-simulacao.component";
import * as _ from "lodash";
import { EtapaService } from "../services/etapa.service";
import { MonitorConferenciaComponent } from "../monitor-conferencia/components/monitor-conferencia.component";
import { SumarioPedidoMonitor } from "../models/sumario-pedido-monitor";
import { EtapasDoPedidoComponent } from "../pedido/etapas-do-pedido/etapas-do-pedido.component";
import { NotaFiscalPedidoModalComponent } from "../modals/nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component";
import { PedidoAnexoComponent } from "../pedido/pedido-anexo/pedido-anexo.component";
import { GiFinSimulacaoModel } from "../dominio/gi-fin-simulacao-model";
import { QueryFilterService } from "../core/services/query-filter-service";
import { TipoSituacaoCadastral } from "../dominio/enums";

// jquery
declare const $: any;

@Component({
  selector: "app-fila",
  templateUrl: "./fila.component.html",
  styleUrls: ["./fila.component.scss"],
})
export class FilaComponent implements OnInit, OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};

  listaStatus = [];

  analiseDesconto: AnaliseDesconto;
  finSimulacao: GiFinSimulacaoModel;

  operadorAtual: FilaFuncionario;

  statusSelecionados: number[] = [0, 1, 2];
  qtdTarefas = 0;

  pesquisa = "";
  pesquisaIntegradorProponente = "";

  tarefaSelecionada: FilaTarefa;

  tarefas: FilaTarefa[] = [];

  TipoFila = TipoFila;

  tipoFila: TipoFila = TipoFila.AnaliseDeDesconto;
  fila: Fila;

  resumoPedido: ResumoPedido;

  textoTarefas = "Tarefas";

  multiFornecedores = false;
  pCentroDistribuicao = false;

  mostrarCodErp = false;

  editandoOperadores = false;
  usuarioLogado: UsuarioLogado;

  administrador = false;
  gestor = false;

  StatusTarefa = StatusTarefa;

  pInicio: Date;
  pFim: Date;
  periodoSelecionado = 4;

  idFilaTarefa;

  intervaloAtualizacaoDados;

  periodos = [
    // { id: 0, name: 'Todos' },
    { id: 1, name: "Mês Atual" },
    { id: 2, name: "Mês Passado" },
    { id: 3, name: "Personalizado" },
    { id: 4, name: "Hoje" },
    { id: 5, name: "Ontem" },
    { id: 6, name: "Semana" },
    { id: 7, name: "Últimos 3 Meses" },
    { id: 8, name: "Últimos 6 Meses" },
    { id: 9, name: "Ano Atual" },
  ];

  operadores: FilaFuncionario[] = [];
  operadorSelecionado = -1;

  fileiras: Fileira[] = [];
  pOcultarColunaDescricaoFileiras = false;
  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  financiamento: Financiamento = new Financiamento();

  possuiProposta = -1;
  opcoesPossuiProposta = [
    { valor: -1, descricao: "Todos" },
    { valor: true, descricao: "Sim" },
    {
      valor: false,
      descricao: "Não",
    },
  ];

  podeVerTudo = false;

  @ViewChild("analiseDescontoComp", { static: false }) analiseDescontoComp: AnaliseDescontoComponent;
  @ViewChild("finSimulacaoComp", { static: false }) finSimulacaoComp: FinSimulacaoComponent;
  @ViewChild("monitorConferenciaComp", { static: false }) monitorConferenciaComp: MonitorConferenciaComponent;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private filaService: FilaService,
    private filaTarefaService: FilaTarefaService,
    private pedidoService: PedidoService,
    private premissasService: PremissasService,
    private analiseDescontoService: AnaliseDescontoService,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private tagService: TagGiService,
    private filaFuncionarioService: FilaFuncionarioService,
    public router: Router,
    public route: ActivatedRoute,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private utilitarioService: UtilitarioService,
    private finSimulacaoService: FinSimulacaoService,
    private queryFilterService: QueryFilterService,
    private financiamentoService: FinanciamentoService,
    private etapaService: EtapaService
  ) {
    this.route.data.subscribe(async (data: Data) => {
      this.tipoFila = data["tipo"];
    });

    if (this.router.getCurrentNavigation().extras.state) {
      this.idFilaTarefa = this.router.getCurrentNavigation().extras.state.idFilaTarefa;
    }
  }

  async ngOnInit() {
    this.globalService.minimizarMenu();

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();

    switch (this.tipoFila) {
      case TipoFila.AnaliseDeDesconto:
        this.podeVerTudo = true;
        this.textoTarefas = "análises";
        this.buscarPremissaOcultarColunaDescricaoFileiras();
        this.buscarEstruturasPersonalizadas();
        break;

      case TipoFila.FinSimulacao:
        {
          this.textoTarefas = "simulações";
          await this.buscarFinanciamento();
          if (!this.financiamento.ativo || !this.financiamento.usaControleTarefas) {
            this.router.navigate(["/"]);
          }
        }
        break;

      case TipoFila.MonitorConferencia:
        this.podeVerTudo = true;
        this.textoTarefas = "pedidos";
        break;

      default:
        break;
    }

    this.buscarMultiFornecedores();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarMostrarCodErp();

    await this.buscarFila();
    await this.buscarIndicadores();

    if (!this.administrador && !this.gestor && this.podeVerTudo) {
      this.operadorSelecionado = this.usuarioLogado.id;
    }

    this.buscarOperadores();

    await this.buscarDados();

    this.intervaloAtualizacaoDados = setInterval(async () => {
      await this.buscarDados();
    }, 30000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervaloAtualizacaoDados);
  }

  async buscarDados() {
    if (!this.idFilaTarefa) {
      this.buscarTarefas();
    } else {
      await this.buscarTarefa(true);
      if (this.analiseDescontoComp !== null && this.analiseDescontoComp !== undefined) {
        this.analiseDescontoComp.buscarLogs();
      }

      if (this.monitorConferenciaComp !== null && this.monitorConferenciaComp !== undefined) {
        this.monitorConferenciaComp.atualizar();
      }
    }

    this.buscarOperadorAtual();
  }

  buscarOperadorAtual() {
    this.carregandoService.mostra("buscarOperadorAtual");
    this.filaFuncionarioService.consultarPorId(this.usuarioLogado.id, this.fila.id).subscribe(
      (func) => {
        this.operadorAtual = func;
        this.carregandoService.esconde("buscarOperadorAtual");
      },
      (erro) => {
        this.carregandoService.esconde("buscarOperadorAtual");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarFila() {
    try {
      this.carregandoService.mostra("buscarFila");
      this.fila = await this.filaService.consultarPorTipo(this.tipoFila).toPromise();
      const gestores: FilaGestor[] = await this.filaService.consultarGestores(this.fila.id).toPromise();
      this.gestor = gestores.some((p) => p.idFuncionario === this.usuarioLogado.id);

      if (this.gestor || this.administrador) {
        this.listaStatus.push({ id: 7, descricao: "Não atribuídas" });
      }

      this.listaStatus.push({ id: 0, descricao: "Não iniciada" });
      this.listaStatus.push({ id: 1, descricao: "Em andamento" });
      this.listaStatus.push({ id: 2, descricao: "Pausada" } /*, { id: 3, descricao: 'Retomada' }*/);

      if (this.fila.habilitaAcaoPositiva) {
        this.listaStatus.push({ id: 4, descricao: this.fila.textoStatusAcaoPositiva });
      }

      if (this.fila.habilitaAcaoNegativa) {
        this.listaStatus.push({ id: 5, descricao: this.fila.textoStatusAcaoNegativa });
      }

      this.listaStatus.push({ id: 6, descricao: "Cancelada" });

      this.listaStatus = [...this.listaStatus];

      this.buscarOperadorAtual();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarFila");
    }
  }

  indicadores = { qtdTarefasNaoIniciadas: 0, qtdTarefasEmAndamento: 0 };

  async buscarIndicadores() {
    try {
      this.carregandoService.mostra("buscarIndicadores");
      this.indicadores = await this.filaService
        .consultarIndicadores(
          this.fila.id,
          this.gestor || this.administrador || this.podeVerTudo
            ? this.operadorSelecionado === -1
              ? null
              : this.operadorSelecionado
            : this.usuarioLogado.id
        )
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarIndicadores");
    }
  }

  selecionouStatus(status: number) {
    if (status === -1)
      return this.statusSelecionados.length > 0 && this.statusSelecionados.length === this.listaStatus.length;
    else return this.statusSelecionados.some((p) => p === status);
  }

  buscarTarefas(clicou: boolean = false) {
    if (clicou) {
      this.tarefaSelecionada = null;
      this.selecionarTarefa(undefined).then();
    }

    this.idFilaTarefa = undefined;

    let pInicio;
    let pFim;

    if (this.pInicio !== null && this.pInicio !== undefined && this.pFim !== null && this.pInicio !== undefined) {
      pInicio = this.pInicio && typeof this.pInicio !== "string" ? this.pInicio.toISOString() : this.pInicio;
      pFim = this.pFim && typeof this.pFim !== "string" ? this.pFim.toISOString() : this.pFim;
    }

    let ordenacao: FilaTarefaTipoOrdenacao = FilaTarefaTipoOrdenacao.ListaFila;

    switch (this.fila.tipo) {
      case TipoFila.AnaliseDeDesconto:
      case TipoFila.MonitorConferencia:
      case TipoFila.FinSimulacao:
        ordenacao = FilaTarefaTipoOrdenacao.DataSolicitacao;
        break;

      // case TipoFila.FinSimulacao:
      //   ordenacao = FilaTarefaTipoOrdenacao.ListaFila;
      //   break;

      default:
        break;
    }

    this.filaTarefaService
      .consultarLista(
        this.fila.tipo,
        this.fila.id,
        this.statusSelecionados,
        null,
        this.gestor || this.administrador || this.podeVerTudo
          ? this.operadorSelecionado === -1
            ? null
            : this.operadorSelecionado
          : this.usuarioLogado.id,
        this.pesquisa,
        this.selecionouStatus(StatusTarefa.NaoAtribuida) || this.selecionouStatus(StatusTarefa.NaoIniciada)
          ? null
          : this.periodoSelecionado,
        pInicio,
        pFim,
        ordenacao,
        1,
        20,
        this.possuiProposta === -1 ? null : this.possuiProposta,
        this.pesquisaIntegradorProponente
      )
      .subscribe(
        async (dados) => {
          if (!_.isEqual(this.tarefas, dados.tarefas)) {
            this.tarefas = dados.tarefas;
            this.buscarDadosAdicionaisTarefas();

            if (this.tarefaSelecionada !== null && this.tarefaSelecionada !== undefined) {
              if (
                !this.tarefas.some(
                  (p) =>
                    p.id === this.tarefaSelecionada.id &&
                    p.idFilaFuncionario === this.tarefaSelecionada.idFilaFuncionario &&
                    p.status === this.tarefaSelecionada.status
                )
              ) {
                this.tarefaSelecionada = undefined;
                await this.buscarTarefa(false);
              }
            }
          }

          this.qtdTarefas = dados.total;

          this.tarefas.forEach(async (p) => {
            if (p.idCupom !== null && p.idCupom !== undefined && p.idCupom) {
              p.buscouTags = false;
              p.tags = await this.buscarTagsPedido(p.idCupom);
              p.buscouTags = true;
            }
          });

          await this.buscarIndicadores();

          if (this.analiseDescontoComp !== null && this.analiseDescontoComp !== undefined) {
            this.analiseDescontoComp.buscarLogs();
          }

          if (this.monitorConferenciaComp !== null && this.monitorConferenciaComp !== undefined) {
            this.monitorConferenciaComp.buscarLogs();
          }

          this.carregandoService.esconde("buscarTarefas");
        },
        (erro) => {
          this.carregandoService.esconde("buscarTarefas");
          this.notificacaoService.erro(erro);
        }
      );
  }

  async buscarTarefa(popularLista: boolean) {
    try {
      this.carregandoService.mostra("buscarTarefa");

      const tarefa: FilaTarefa = await this.filaTarefaService.consultarPorId(this.idFilaTarefa).toPromise();

      if (!this.administrador && !this.gestor && tarefa.idFilaFuncionario !== this.usuarioLogado.id) {
        this.tarefaSelecionada = undefined;

        if (this.tarefas !== null && this.tarefas !== undefined && this.tarefas.some((p) => p.id === tarefa.id)) {
          this.tarefas.splice(this.tarefas.indexOf(this.tarefas.find((p) => p.id === tarefa.id)), 1);
        }

        return;
      }

      if (
        this.tarefaSelecionada !== null &&
        this.tarefaSelecionada !== undefined &&
        tarefa.id === this.tarefaSelecionada.id &&
        tarefa.idFilaFuncionario === this.tarefaSelecionada.idFilaFuncionario &&
        tarefa.status === this.tarefaSelecionada.status
      ) {
        return;
      }

      if (tarefa.idCupom !== null && tarefa.idCupom !== undefined && tarefa.idCupom) {
        tarefa.tags = await this.buscarTagsPedido(tarefa.idCupom);
        tarefa.buscouTags = true;
      }

      await this.selecionarTarefa(tarefa);

      if (popularLista) {
        this.tarefas = [tarefa];
        this.buscarDadosAdicionaisTarefas();
      }
    } catch (erro) {
    } finally {
      this.carregandoService.esconde("buscarTarefa");
    }

    this.filaTarefaService.consultarPorId(this.idFilaTarefa).subscribe(
      async (tarefa) => {
        this.tarefas = [tarefa];
        this.buscarDadosAdicionaisTarefas();

        this.tarefas.forEach(async (p) => {
          if (p.idCupom !== null && p.idCupom !== undefined && p.idCupom) {
            p.tags = await this.buscarTagsPedido(p.idCupom);
            p.buscouTags = true;
          }
        });

        if (this.tarefaSelecionada !== null && this.tarefaSelecionada !== undefined) {
          if (
            !this.tarefas.some(
              (p) =>
                p.id === this.tarefaSelecionada.id &&
                p.idFilaFuncionario === this.tarefaSelecionada.idFilaFuncionario &&
                p.status === this.tarefaSelecionada.status
            )
          )
            this.tarefaSelecionada = null;
        } else {
          this.selecionarTarefa(this.tarefas[0]);
        }

        this.qtdTarefas = 0;

        await this.buscarIndicadores();

        if (this.analiseDescontoComp !== null && this.analiseDescontoComp !== undefined) {
          this.analiseDescontoComp.buscarLogs();
        }

        if (this.monitorConferenciaComp !== null && this.monitorConferenciaComp !== undefined) {
          this.monitorConferenciaComp.buscarLogs();
        }

        this.carregandoService.esconde("buscarTarefa");
      },
      (erro) => {
        this.carregandoService.esconde("buscarTarefa");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResumoPedido() {
    this.buscarFileiras();

    this.carregandoService.mostra("buscarResumoPedido");

    this.pedidoService.consultarResumo(this.tarefaSelecionada.idCupom).subscribe(
      (dados) => {
        this.resumoPedido = dados;
        this.buscarPedidoSumario();
        this.carregandoService.esconde("buscarResumoPedido");
      },
      (erro) => {
        this.carregandoService.esconde("buscarResumoPedido");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async selecionarTarefa(tarefa: FilaTarefa) {
    this.editandoOperadores = false;

    if (this.tarefaSelecionada !== tarefa) {
      this.analiseDesconto = undefined;
      this.finSimulacao = undefined;
      this.tarefaSelecionada = tarefa;

      switch (tarefa.tipo) {
        case TipoTarefa.AnaliseDeDesconto:
          this.buscarResumoPedido();
          this.analiseDesconto = await this.buscarAnalise(tarefa);
          break;

        case TipoTarefa.FinSimulacao:
          this.finSimulacao = await this.buscarFinSimulacao(tarefa);
          break;

        case TipoTarefa.MonitorConferencia:
          this.buscarResumoPedido();
          break;

        default:
          break;
      }
    }
  }

  async alterarStatus(status: StatusTarefa, tarefa: FilaTarefa, reload: boolean = false) {
    swal({
      title: "Atenção!!",
      html: 'Deseja realmente <span class="negrito">' + this.retornarTextoAcao(status) + "</span>?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-info",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        switch (tarefa.tipo) {
          case TipoTarefa.AnaliseDeDesconto: {
            const analiseDesconto =
              !this.analiseDesconto || this.analiseDesconto === null || this.analiseDesconto.idTarefa !== tarefa.id
                ? await this.buscarAnalise(tarefa)
                : this.analiseDesconto;

            switch (status) {
              case StatusTarefa.Ganha:
              case StatusTarefa.Perdida:
                this.concluirAnaliseDesconto(tarefa, analiseDesconto, status === StatusTarefa.Ganha ? 0 : 1);
                break;

              case StatusTarefa.Pausada:
              case StatusTarefa.Cancelada:
                {
                  const largura = Number($("body").width());

                  const dialogRef = this.dialog.open(JustificativaModalComponent, {
                    width: largura > 730 ? "700px" : $("body").width().toString() + "px",
                    data: { tipo: 1 },
                    panelClass: "modal-card",
                  });

                  dialogRef.afterClosed().subscribe(async (resultJust) => {
                    if (resultJust) {
                      const resultado = await this.alterarStatusAnalise(analiseDesconto, status, resultJust);

                      if (this.selecionouStatus(resultado.tarefa.status)) {
                        await this.atualizarDadosTarefaAnaliseDesconto(tarefa, resultado);
                      } else {
                        this.tarefaSelecionada = undefined;
                      }

                      await this.buscarDados();
                    }
                  });
                }

                break;

              default: {
                const resultado = await this.alterarStatusAnalise(analiseDesconto, status, null);

                await this.atualizarDadosTarefaAnaliseDesconto(tarefa, resultado);
                await this.buscarDados();

                break;
              }
            }

            break;
          }

          case TipoTarefa.FinSimulacao: {
            const finSimulacao =
              !this.finSimulacao || this.finSimulacao === null || this.finSimulacao.idTarefa !== tarefa.id
                ? await this.buscarFinSimulacao(tarefa)
                : this.finSimulacao;

            switch (status) {
              case StatusTarefa.Ganha:
                {
                  if (!(await this.possuiVinculosFinanciadorasDisponiveis(finSimulacao, tarefa.id))) {
                    swal({
                      title: "ATENÇÃO!!!",
                      html: "Nenhuma proposta disponível!!!",
                      buttonsStyling: false,
                      confirmButtonClass: "btn btn-warning",
                      type: "warning",
                    }).catch(swal.noop);
                  } else {
                    const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, null);

                    await this.alterarStatusFinSimulacao(tarefa.id, null);

                    if (this.selecionouStatus(tarefaAtualizada.status)) {
                      await this.atualizarDadosTarefaFinSimulacao(tarefa, await this.buscarFinSimulacao(tarefa));
                    } else {
                      this.tarefaSelecionada = undefined;
                    }

                    await this.buscarDados();
                  }
                }
                break;

              case StatusTarefa.Perdida:
                {
                  const largura = Number($("body").width());

                  const dialogRef = this.dialog.open(JustificativaModalComponent, {
                    width: largura > 730 ? "700px" : $("body").width().toString() + "px",
                    data: { tipo: 1 },
                    panelClass: "modal-card",
                  });

                  dialogRef.afterClosed().subscribe(async (resultJust) => {
                    if (resultJust) {
                      const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, resultJust);

                      await this.alterarStatusFinSimulacao(tarefa.id, resultJust);

                      if (this.selecionouStatus(tarefaAtualizada.status)) {
                        await this.atualizarDadosTarefaFinSimulacao(tarefa, await this.buscarFinSimulacao(tarefa));
                      } else {
                        this.tarefaSelecionada = undefined;
                      }

                      await this.buscarDados();
                    }
                  });
                }
                break;

              case StatusTarefa.Cancelada:
                {
                  const largura = Number($("body").width());

                  const dialogRef = this.dialog.open(JustificativaModalComponent, {
                    width: largura > 730 ? "700px" : $("body").width().toString() + "px",
                    data: { tipo: 1 },
                    panelClass: "modal-card",
                  });

                  dialogRef.afterClosed().subscribe(async (resultJust) => {
                    if (resultJust) {
                      const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, resultJust);

                      await this.alterarStatusFinSimulacao(tarefa.id, resultJust);

                      if (this.selecionouStatus(tarefaAtualizada.status)) {
                        await this.atualizarDadosTarefaFinSimulacao(tarefa, await this.buscarFinSimulacao(tarefa));
                      } else {
                        this.tarefaSelecionada = undefined;
                      }

                      await this.buscarDados();
                    }
                  });
                }

                break;

              case StatusTarefa.Pausada:
                {
                  const largura = Number($("body").width());

                  const dialogRef = this.dialog.open(JustificativaModalComponent, {
                    width: largura > 730 ? "700px" : $("body").width().toString() + "px",
                    data: { tipo: 1 },
                    panelClass: "modal-card",
                  });

                  dialogRef.afterClosed().subscribe(async (resultJust) => {
                    if (resultJust) {
                      const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, resultJust);

                      if (this.selecionouStatus(tarefaAtualizada.status)) {
                        await this.atualizarDadosTarefaFinSimulacao(tarefa, {
                          tarefa: tarefaAtualizada,
                          simulacao: finSimulacao,
                        });
                      } else {
                        this.tarefaSelecionada = undefined;
                      }

                      await this.buscarDados();
                    }
                  });
                }

                break;

              default: {
                const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, null);

                await this.atualizarDadosTarefaFinSimulacao(tarefa, {
                  tarefa: tarefaAtualizada,
                  simulacao: finSimulacao,
                });
                await this.buscarDados();

                break;
              }
            }

            break;
          }

          case TipoTarefa.MonitorConferencia: {
            switch (status) {
              case StatusTarefa.Ganha:
              case StatusTarefa.Perdida:
                this.concluirMonitorConferencia(tarefa, status);
                break;

              case StatusTarefa.Pausada:
                {
                  const largura = Number($("body").width());

                  const dialogRef = this.dialog.open(JustificativaModalComponent, {
                    width: largura > 730 ? "700px" : $("body").width().toString() + "px",
                    data: { tipo: 1 },
                    panelClass: "modal-card",
                  });

                  dialogRef.afterClosed().subscribe(async (resultJust) => {
                    if (resultJust) {
                      const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, resultJust);

                      if (this.selecionouStatus(tarefaAtualizada.status)) {
                        await this.atualizarDadosTarefaMonitorConferencia(tarefa, tarefaAtualizada);
                      } else {
                        this.tarefaSelecionada = undefined;
                      }

                      await this.buscarDados();
                    }
                  });
                }

                break;

              case StatusTarefa.Cancelada: {
                break;
              }

              default: {
                const tarefaAtualizada = await this.alterarStatusTarefa(tarefa.id, status, null);

                await this.atualizarDadosTarefaMonitorConferencia(tarefa, tarefaAtualizada);
                await this.buscarDados();

                break;
              }
            }

            break;
          }

          default:
            break;
        }

        if (reload) {
          if (this.finSimulacaoComp) {
            localStorage.setItem("fin_simulacao_active_tab", String(this.finSimulacaoComp.tabIndex));
          }

          this.tarefaSelecionada = undefined;
          await this.selecionarTarefa(tarefa);
        }
      }
    });
  }

  async atualizarDadosTarefaAnaliseDesconto(tarefa: FilaTarefa, resultado: any) {
    tarefa.status = resultado.tarefa.status;
    tarefa.dtStatus = resultado.tarefa.dtStatus;
    tarefa.statusDescricao = resultado.tarefa.statusDescricao;

    if (this.analiseDesconto && this.analiseDesconto.id === resultado.analise.id) {
      this.analiseDesconto.status = resultado.analise.status;
      this.analiseDesconto.dtStatus = resultado.analise.dtStatus;
      this.analiseDesconto.statusDescricao = resultado.analise.statusDescricao;
    }
  }

  async atualizarDadosTarefaFinSimulacao(tarefa: FilaTarefa, resultado: any) {
    tarefa.status = resultado.tarefa.status;
    tarefa.dtStatus = resultado.tarefa.dtStatus;
    tarefa.statusDescricao = resultado.tarefa.statusDescricao;

    if (this.finSimulacao && this.finSimulacao.id === resultado.simulacao.id) {
      this.finSimulacao.status = resultado.simulacao.status;
      this.finSimulacao.dtStatus = resultado.simulacao.dtStatus;
      this.finSimulacao.status = resultado.simulacao.status;

      if (this.finSimulacaoComp) {
        this.finSimulacaoComp.atualizar();
      }
    }
  }

  async atualizarDadosTarefaMonitorConferencia(tarefa: FilaTarefa, tarefaAtualizada: FilaTarefa) {
    tarefa.status = tarefaAtualizada.status;
    tarefa.dtStatus = tarefaAtualizada.dtStatus;
    tarefa.statusDescricao = tarefaAtualizada.statusDescricao;

    if (this.monitorConferenciaComp) {
      this.monitorConferenciaComp.atualizar();
    }
  }

  retornarTextoStatus(tarefa: FilaTarefa) {
    switch (tarefa.status) {
      case StatusTarefa.Ganha:
        return this.fila.textoStatusAcaoPositiva;

      case StatusTarefa.Perdida:
        return this.fila.textoStatusAcaoNegativa;

      default:
        return tarefa.statusDescricao;
    }
  }

  retornarTextoAcao(status: StatusTarefa) {
    switch (status) {
      case StatusTarefa.Ganha:
        return this.fila.textoAcaoPositiva;

      case StatusTarefa.Perdida:
        return this.fila.textoAcaoNegativa;

      case StatusTarefa.Iniciada:
        return "Iniciar";

      case StatusTarefa.Pausada:
        return "Pausar";

      case StatusTarefa.Retomada:
        return "Retomar";

      case StatusTarefa.Cancelada:
        return "Cancelar";
    }
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra("consultarMultiFornecedores");
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;

        this.carregandoService.esconde("consultarMultiFornecedores");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMultiFornecedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra("buscarPremissaCentroDeDistribuicao");
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.pCentroDistribuicao = f.valor;

        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra("buscarMostrarCodErp");
    this.premissasService.consultarMostrarCodErp().subscribe(
      (f) => {
        this.mostrarCodErp = f.valor;
        this.carregandoService.esconde("buscarMostrarCodErp");
      },
      (erro) => {
        this.carregandoService.esconde("buscarMostrarCodErp");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarAnalise(tarefa: FilaTarefa) {
    try {
      this.carregandoService.mostra("buscarAnalise");
      return await this.analiseDescontoService.consultarAnalisePorIdTarefa(tarefa.id).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarAnalise");
    }
  }

  async alterarStatusAnalise(analiseDesconto: AnaliseDesconto, status, obs) {
    try {
      this.carregandoService.mostra("alterarStatusAnalise");
      return await this.analiseDescontoService.alterarStatusAnalise(analiseDesconto.id, status, obs).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("alterarStatusAnalise");
    }
  }

  async buscarFinSimulacao(tarefa: FilaTarefa) {
    try {
      this.carregandoService.mostra("buscarFinSimulacao");
      return (await this.finSimulacaoService.consultarSimulacaoPorIdTarefa(tarefa.id).toPromise()).result;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarFinSimulacao");
    }
  }

  async possuiVinculosFinanciadorasDisponiveis(simulacao: GiFinSimulacaoModel, idTarefa: number) {
    try {
      this.carregandoService.mostra("possuiVinculosFinanciadorasDisponiveis");

      const queryFilter = this.queryFilterService
        .getQueryBuilder()
        .addCondition("status", "=", "8") // Status Disponível
        .build();

      const resultado = await this.finSimulacaoService.buscarPropostasV2Tarefa(idTarefa, queryFilter).toPromise();

      return resultado.results.length > 0;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("possuiVinculosFinanciadorasDisponiveis");
    }
  }

  async alterarStatusFinSimulacao(idTarefa: number, mensagem: string | null = null) {
    try {
      this.carregandoService.mostra("alterarStatusFinSimulacao");
      return await this.finSimulacaoService.alterarStatusSimulacaoPorTarefa(idTarefa, mensagem).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("alterarStatusFinSimulacao");
    }
  }

  async alterarStatusTarefa(id, status, obs) {
    try {
      this.carregandoService.mostra("alterarStatusTarefa");
      return await this.filaTarefaService.alterarStatusTarefa(id, status, obs).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("alterarStatusTarefa");
    }
  }

  async iniciarTarefa(tarefa: FilaTarefa) {
    await this.alterarStatus(StatusTarefa.Iniciada, tarefa, true);
  }

  async pausarTarefa(tarefa: FilaTarefa) {
    await this.alterarStatus(StatusTarefa.Pausada, tarefa);
  }

  async concluirTarefa(tarefa: FilaTarefa, status: StatusTarefa) {
    await this.alterarStatus(status, tarefa);
  }

  async retomarTarefa(tarefa: FilaTarefa) {
    await this.alterarStatus(StatusTarefa.Iniciada, tarefa);
  }

  async cancelarTarefa(tarefa: FilaTarefa) {
    await this.alterarStatus(StatusTarefa.Cancelada, tarefa);
  }

  podeIniciar(tarefa: FilaTarefa) {
    return (
      tarefa.idFilaFuncionario !== null &&
      tarefa.idFilaFuncionario !== undefined &&
      tarefa.status === StatusTarefa.NaoIniciada
    );
  }

  podeConcluir(tarefa: FilaTarefa) {
    return tarefa.status === StatusTarefa.Iniciada || tarefa.status === StatusTarefa.Retomada;
  }

  podePausar(tarefa: FilaTarefa) {
    return tarefa.status === StatusTarefa.Iniciada || tarefa.status === StatusTarefa.Retomada;
  }

  podeRetomar(tarefa: FilaTarefa) {
    return tarefa.status === StatusTarefa.Pausada;
  }

  podeCancelar(tarefa: FilaTarefa) {
    return (
      tarefa.tipo !== TipoTarefa.MonitorConferencia &&
      (tarefa.status === StatusTarefa.NaoIniciada || tarefa.status === StatusTarefa.Pausada)
    );
  }

  togglePrioridade(tarefa: FilaTarefa) {
    this.carregandoService.mostra("togglePrioridade");
    this.filaTarefaService.definirPrioridade(tarefa.id, !tarefa.temPrioridade).subscribe(
      (f) => {
        tarefa.temPrioridade = !tarefa.temPrioridade;
        this.carregandoService.esconde("togglePrioridade");
      },
      (erro) => {
        this.carregandoService.esconde("togglePrioridade");
        this.notificacaoService.erro(erro);
      }
    );
  }

  alterarOperador(tarefa: FilaTarefa) {
    const dialogRef = this.dialog.open(FilaSelOperadorModalComponent, {
      width: "423px",
      data: {
        idFila: this.fila.id,
      },
      panelClass: ["modal-card", "modal-card-v2"],
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result && result !== tarefa.idFilaFuncionario) {
        swal({
          title: "Atenção!!",
          html: 'Deseja realmente <span class="negrito">(re)atribuir</span>?',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-info",
          cancelButtonClass: "btn btn-danger",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          buttonsStyling: false,
        }).then(async (res) => {
          if (res.value) {
            try {
              this.carregandoService.mostra("alterarOperador");
              await this.filaTarefaService.vincularTarefaComFuncionario(tarefa, result).toPromise();
              this.buscarTarefas();
            } catch (erro) {
              this.notificacaoService.erro(erro);
            } finally {
              this.carregandoService.esconde("alterarOperador");
            }
          }
        });
      }
    });
  }

  async vincularTarefasSemFuncionario() {
    try {
      this.carregandoService.mostra("vincularTarefasSemFuncionario");
      await this.filaTarefaService.vincularTarefasSemFuncionario(this.fila.id).toPromise();
      this.buscarTarefas();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("vincularTarefasSemFuncionario");
    }
  }

  async buscarTagsPedido(idCupom: string) {
    try {
      const comLog = true;
      const tags = await this.tagService.consultarPorIdCupom(idCupom, comLog).toPromise();
      return tags;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  concluirAnaliseDesconto(tarefa: FilaTarefa, analiseDesconto: AnaliseDesconto, tipoConclusao: number) {
    if (tipoConclusao === 0 && !analiseDesconto.descontoValido) {
      swal({
        title: "ATENÇÃO!!!",
        html: "Não foi possível concluir!! Desconto inválido!!!",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-warning",
        type: "warning",
      }).catch(swal.noop);

      return;
    }

    const dialogRef = this.dialog.open(AnaliseDescontoConclusaoModalComponent, {
      width: "423px",
      data: {
        analiseDesconto: Object.assign({}, analiseDesconto),
        tipoConclusao: tipoConclusao,
        descontoMaximo: this.usuarioLogado.limDesc,
      },
      panelClass: ["modal-card", "modal-card-v2"],
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        if (this.selecionouStatus(-1) || this.selecionouStatus(result.tarefa.status)) {
          await this.atualizarDadosTarefaAnaliseDesconto(tarefa, result);
        } else {
          this.tarefaSelecionada = undefined;
        }

        await this.buscarDados();
      }
    });
  }

  async concluirMonitorConferencia(tarefa: FilaTarefa, status) {
    try {
      this.carregandoService.mostra("concluirMonitorConferencia");
      const tarefaAtualizada = await this.etapaService.concluirFilaTarefa(tarefa.id, status).toPromise();
      if (this.selecionouStatus(-1) || this.selecionouStatus(tarefaAtualizada.status)) {
        await this.atualizarDadosTarefaMonitorConferencia(tarefa, tarefaAtualizada);
      } else {
        this.tarefaSelecionada = undefined;
      }
      await this.buscarDados();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("concluirMonitorConferencia");
    }
  }

  async toggleStatus(operador: FilaFuncionario) {
    try {
      operador.disponivel = !operador.disponivel;
      this.carregandoService.mostra("buscarOperadores");
      await this.filaFuncionarioService.salvar(operador).toPromise();
    } catch (erro) {
      operador.disponivel = !operador.disponivel;
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarOperadores");
    }
  }

  exibirObservacoes() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(ObservacoesModalComponent, {
      width: largura > 1050 ? "1000px" : $("body").width().toString() + "px",
      data: { idCupom: this.tarefaSelecionada.idCupom, ocultarBotoes: true },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  selecionarTag() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(SelecionarTagModalComponent, {
      width: largura > 850 ? "800px" : $("body").width().toString() + "px",
      data: {
        idCupom: this.resumoPedido.idCupom,
        tags: this.resumoPedido.tags.map((t) => t.id),
        somenteIncluir: true,
        tipo: TipoTag.pedido,
      },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarResumoPedido();
      }
    });
  }

  buscarOperadores() {
    this.carregandoService.mostra("buscarOperadores");
    this.filaFuncionarioService.consultarLista(this.fila.id, false).subscribe(
      (funcs) => {
        this.operadores = funcs;
        const todos = new FilaFuncionario();
        todos.idFuncionario = -1;
        todos.nome = "Todos";
        this.operadores.unshift(todos);
        this.carregandoService.esconde("buscarOperadores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarOperadores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFileiras() {
    this.carregandoService.mostra("buscarFileiras");
    this.pedidoService.buscarFileiras(this.tarefaSelecionada.idCupom).subscribe(
      (fileiras) => {
        this.fileiras = fileiras;

        this.fileiras.forEach((forn: any) => {
          if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
            forn.logo$ = this.fornecedorEstruturaService
              .consultarImagemPorId(forn.idFornecedorEstrutura)
              .map((m) =>
                m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve("")
              )
              .toPromise();
            forn.logo$.then((p) => {
              forn.buscouImagem = true;
            });
          }
        });
        this.carregandoService.esconde("buscarFileiras");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFileiras");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaOcultarColunaDescricaoFileiras() {
    this.carregandoService.mostra("buscarPremissaOcultarColunaDescricaoFileiras");
    this.premissasService.consultarOcultarColunaDescricaoFileiras().subscribe(
      (f) => {
        if (f.valor) {
          this.pOcultarColunaDescricaoFileiras = true;
        }

        this.carregandoService.esconde("buscarPremissaOcultarColunaDescricaoFileiras");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaOcultarColunaDescricaoFileiras");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarDescricaoTelhado(fileira: Fileira) {
    switch (fileira.telhado) {
      case 8:
        return this.estruturasPersonalizadas.textoFibrometal;

      case 12: {
        return this.estruturasPersonalizadas.textoEstruturaCalhetao;
      }

      case 13:
        return this.estruturasPersonalizadas.textoEstruturaCarport;

      default:
        return fileira.telhadoDescricao;
    }
  }

  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra("buscarEstruturasPersonalizadas");
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (f) => {
        this.estruturasPersonalizadas = f;

        this.carregandoService.esconde("buscarEstruturasPersonalizadas");
      },
      (erro) => {
        this.carregandoService.esconde("buscarEstruturasPersonalizadas");
        this.notificacaoService.erro(erro);
      }
    );
  }

  nomeArquivoEstrutura(fileira) {
    if (fileira.fornecedor === undefined || fileira.fornecedor === null) {
      return "semestrutura";
    } else {
      switch (fileira.fornecedor) {
        case 0:
          return "alfix";
        case 1:
          return "photoenergy";
        case 2:
          return "gosolar";
        case 3:
          return "fotus";
        case 4:
        case 10:
          return "romagnole";
        case 5:
          return "brassunny";
        case 6:
          return "ssm";
        case 7:
          return "lbsolar";
        case 8:
          return "viener";
        case 9:
          return "ccm";
        case 11:
          return "bellesystem";
        case 12:
          return "pratyc";
        case 13:
          return "e3";
        case 14:
          return "solargroup";
        case 15:
        case 16:
        case 17:
          return "vertys";
        case 18:
          return "k2";
      }
    }
  }

  detalhesDaEstrutura(itens) {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(DetalheEstruturaModalComponent, {
      width: largura > 850 ? "800px" : $("body").width().toString() + "px",
      data: {
        itens: itens,
      },
      panelClass: "modal-card",
      maxHeight: "90vh",
    });
  }

  calcularTotalLayout() {
    let soma = 0;

    this.fileiras.forEach((fileira) => {
      soma += fileira.valorTotal;
    });
    return soma;
  }

  async buscarFinanciamento() {
    try {
      this.carregandoService.mostra("buscarFinanciamento");

      this.financiamento = (await this.financiamentoService.buscar().toPromise()).result;

      this.carregandoService.esconde("buscarFinanciamento");
    } catch (erro) {
      this.carregandoService.esconde("buscarFinanciamento");
      this.notificacaoService.erro(erro);
    }
  }

  buscarDadosAdicionaisSimulacoes() {
    this.tarefas.forEach((p) => {
      this.buscarDadosAdicionaisSimulacacao(p);
    });
  }

  buscarDadosAdicionaisSimulacacao(tarefa: FilaTarefa) {
    this.carregandoService.mostra("buscarDadosAdicionaisSimulacacao");
    this.finSimulacaoService.buscarSumarioSimulacaoCelula(tarefa.id).subscribe(
      (f) => {
        tarefa.idSimulacao = f.result.idSimulacao;
        tarefa.qtdPropostas = f.result.qtdPropostas;
        this.carregandoService.esconde("buscarDadosAdicionaisSimulacacao");
      },
      (erro) => {
        this.carregandoService.esconde("buscarDadosAdicionaisSimulacacao");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarDadosAdicionaisTarefas() {
    switch (this.tipoFila) {
      case TipoFila.AnaliseDeDesconto:
        break;

      case TipoFila.FinSimulacao:
        {
          this.buscarDadosAdicionaisSimulacoes();
        }
        break;

      default:
        break;
    }
  }

  formatarIdsExibicao(tarefa: FilaTarefa) {
    let texto = "";

    switch (this.tipoFila) {
      case TipoFila.AnaliseDeDesconto:
      case TipoFila.MonitorConferencia:
        texto = tarefa.idCupom;
        break;

      case TipoFila.FinSimulacao:
        {
          if (tarefa.idSimulacao !== null && tarefa.idSimulacao !== undefined && tarefa.idSimulacao) {
            texto = tarefa.idSimulacao.toString().padStart(4, "0");

            if (tarefa.idCupom !== null && tarefa.idCupom !== undefined && tarefa.idCupom) {
              texto += ` | ${tarefa.idCupom}`;
            }
          }
        }
        break;

      default:
        break;
    }

    return texto;
  }

  buscarPedidoSumario() {
    return this.pedidoService.sumarioPedidoMonitor(this.resumoPedido.idCupom).subscribe(
      (sumario: SumarioPedidoMonitor) => {
        this.resumoPedido.possuiAnexos = sumario.possuiAnexos;
        this.resumoPedido.possuiMensagens = sumario.possuiMensagens;
        this.resumoPedido.possuiNotasFiscais = sumario.possuiNotasFiscais;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  acompanharPedido(idCupom) {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(EtapasDoPedidoComponent, {
      width: largura > 930 ? "900px" : $("body").width().toString() + "px",
      data: { idCupom: idCupom },
      panelClass: "modal-card",
    });
  }

  notasFiscais(idCupom) {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? "800px" : $("body").width().toString() + "px",
      data: {
        idCupom: idCupom,
        podeAdicionarNota: false,
      },
      panelClass: "modal-card",
    });
  }

  anexos(idCupom) {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: $("body").width().toString() + "px",
      data: {
        idPedido: idCupom,
        podeEditar: true,
      },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidoSumario();
      }
    });
  }

  irParaMonitorConferenciaAntigo() {
    this.router.navigate(["/monitoramento-conferencia"]);
  }

  buscarDataParaExibir(tarefa: FilaTarefa) {
    switch (this.fila.tipo) {
      case TipoFila.AnaliseDeDesconto:
      case TipoFila.MonitorConferencia:
        return tarefa.dtCriacao;

      default:
        return tarefa.dtAtribuicao;
    }
  }
}
